import {useRef} from 'react';
import {useDraggable} from 'react-use-draggable-scroll';
import {ProductSummary} from '~/features/shared';
import {ProductItem} from '../ProductItem';

export interface ProductsSliderDesktopProps {
  items: ProductSummary[];
}

export function ProductsSliderDesktop({items}: ProductsSliderDesktopProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  // @ts-ignore
  const {events} = useDraggable(ref);

  return (
    <div
      {...events}
      ref={ref}
      className="hidden overflow-x-auto gap-10 px-5 sm:px-10 md:flex xl:px-4 scrollbar-hide lg:px-30 xl:before:m-auto xl:after:m-auto"
    >
      {items.map((item) => {
        return (
          <ProductItem
            key={item.handle}
            product={item}
            imageClassName="h-[12rem]"
            className="flex-shrink-0 w-[20rem]"
          />
        );
      })}
    </div>
  );
}
